export default __webpack_public_path__ + "static/char-61-5ea8c93c2d8f9035c0b58609573aa574.gif";